module.exports = __webpack_public_path__ + "img/manage-access-icon.4b14186d.svg";